import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-screen h-screen flex items-center justify-center fixed top-0 left-0 z-[9998]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "bg-white w-screen h-screen fixed top-0 left-0 opacity-25" }, null, -1)

import SpinnerLoader from '@/components/Elements/SpinnerLoader.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'FullPageLoader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(SpinnerLoader, { class: "fill-secondary w-12 h-12" })
  ]))
}
}

})